/**
 * Shared enums for the Journal App.
 */

/** Sync status for journal entries (local and server). */
export enum SyncStatus {
  Synced = 'synced',
  Pending = 'pending',
  Conflict = 'conflict',
  Error = 'error',
}

/** Conflict resolution choice. */
export enum ConflictResolution {
  VersionA = 'A',
  VersionB = 'B',
}

/** Media upload status for pending media items. */
export enum MediaStatus {
  Pending = 'pending',
  Uploading = 'uploading',
  Failed = 'failed',
}

/** Actions that can be queued for offline sync. */
export enum SyncAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}
